import { Stack } from "@fluentui/react";

import undrawNoData from "@/assets/images/undraw_no_data_qbuo.svg";

interface NoDataFoundProps {
  title?: string;
  alt?: string;
  imageSrc?: string;
  imageWidth?: string;
  imageHeight?: string;
}

export function NoDataFound({
  title = "Nenhum dado encontrado no banco",
  alt = "Nenhum dado encontrado no banco",
  imageSrc = undrawNoData,
  imageWidth = "55vh",
  imageHeight = "55vh"
}: NoDataFoundProps): JSX.Element {
  return (
    <Stack
      styles={{
        root: {
          alignItems: "center"
        }
      }}
    >
      <img
        src={imageSrc}
        title={title}
        alt={alt}
        style={{ width: imageWidth, height: imageHeight }}
      />
    </Stack>
  );
}
